import { Loader } from "lucide-react";
import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table";
import { Skeleton } from "@/components/ui/skeleton";
import { randomRange } from "@/utils";
import { Card } from "../ui/card";

export function LoaderSpin({}) {
  return <Loader className="ml-2 h-4 w-4 animate-spin" />;
}

export function LoaderTable({
  lines,
  cols,
  width,
}: {
  lines: number;
  cols: number;
  width: () => number;
}) {
  return (
    <Table>
      <TableBody>
        {Array(lines)
          .fill(null)
          .map((_, index) => {
            return (
              <TableRow key={index}>
                {Array(cols)
                  .fill(null)
                  .map((_, index) => {
                    return (
                      <TableCell key={index}>
                        <Skeleton
                          className="h-5"
                          style={{
                            width: `${width()}px`,
                          }}
                        />
                      </TableCell>
                    );
                  })}
              </TableRow>
            );
          })}
      </TableBody>
    </Table>
  );
}

export const CreateLoaderTable = ({
  cols,
  lines = 10,
  min = 5,
  max = 15,
}: {
  lines?: number;
  cols: number;
  min?: number;
  max?: number;
}) => (
  <Card className="w-full max-w-full overflow-x-visible">
    <LoaderTable
      lines={lines}
      cols={cols}
      width={() => randomRange(min, max) * 8}
    />
  </Card>
);

export const CreateLoaderBox = ({
  cols = 2,
  lines = 2,
}: {
  cols?: number;
  lines?: number;
}) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {Array(cols * lines)
        .fill(null)
        .map((_, index) => (
          <div
            key={index}
            className="bg-white dark:bg-zinc-800 rounded-lg p-4 shadow h-[400px] animate-pulse"
          >
            <div className="h-6 w-3/4 bg-gray-200 dark:bg-zinc-700 rounded mb-4 mx-auto" />
            <div className="h-[320px] bg-gray-200 dark:bg-zinc-700 rounded" />
          </div>
        ))}
    </div>
  );
};

export const LoaderInputForm = () => {
  return (
    <div className="flex">
      <div className="space-y-1">
        <Skeleton className="h-4 w-[200px]" />
        <Skeleton className="h-5 w-[250px]" />
      </div>
    </div>
  );
};
export const LoaderCardLesson = () => {
  return (
    <div className="border border-gray-200 dark:border-gray-600 rounded-md flex h-[180px] bg-[#f4f4f8] shadow-sm dark:bg-transparent">
      <Skeleton className="h-full w-1/3" />
      <div className="flex flex-col justify-between items-end flex-auto w-2/3">
        <div className="p-2 h-full flex items-end">
          <Skeleton className="h-6 w-20" />
        </div>
        <div className="w-full flex justify-end items-center border-t-2 border-gray-200 dark:border-gray-600 dark:border-t p-2">
          <Skeleton className="h-6 w-32" />
        </div>
      </div>
    </div>
  );
};

export const CreateLoaderInput = ({ lines = 1 }: { lines?: number }) => {
  return (
    <div className="flex flex-col space-y-4">
      {Array(lines)
        .fill(null)
        .map((_, index) => (
          <LoaderInputForm key={index} />
        ))}
    </div>
  );
};

export const CreateGridLoaderCard = ({
  quantityItems = 1,
}: {
  quantityItems?: number;
}) => {
  return (
    <div className="grid grid-cols-[repeat(auto-fit,_minmax(28rem,_1fr))] gap-2">
      {Array(quantityItems)
        .fill(null)
        .map((_, index) => (
          <LoaderCardLesson key={index} />
        ))}
    </div>
  );
};
